<influencer-module-container 
    [title]="'INFLUENCER.insight.interaction_rate_by_channel.title' | translate"
    [hasNoData]="hasNoData"
    [isFetchingData]="isFetchingData"
    [height]="'265px'">

    <div *ngIf="drawData" class="content-container">
        <div class="percentage-header">%</div>

        <div class="chart-container">
            <div *ngFor="let column of drawData.columns" class="chart-column" 
                [style.width]="column.maxWidthPercentage">

                <div class="column-box" >
                    <div class="box" [style.background]="column.color" [style.height]="column.heightPercentage">
                        <div *ngIf="!column.placeholderMode" class="column-percentage">{{column.interactionRate | percentNumberSuffix:1}}</div> 
                    </div>
                </div>

                <div class="column-title">
                    <div class="title-row">
                        <div class="title">
                            <div>{{column.channelName}}</div>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>

        <div class="y-axis-container">
            <div class="y-values-container">
                <div *ngFor="let y of drawData.yAxisValues" class="y-value" [style.bottom]="y.bottomPercentage">{{y.value | number:'1.0-1'}}</div>
            </div>
        </div>
    </div>
</influencer-module-container>


// WEBPACK FOOTER //
// ./src/app/main/influencer/influencer-insight/interaction-rate-by-channel/interaction-rate-by-channel.component.html